import React from "react";
import { Routes, Route } from "react-router-dom";
import AlumniHome from "../alumnicomponents/AlumniHome";
import LoginAlumni from "../alumnicomponents/loginalumni";
import SignupAlumni from "../alumnicomponents/signupalumni";
import DashboardAlumni from "../alumnicomponents/dashboardalumni";

function Alumni() {
  return (
    <Routes>
      <Route path="/" element={<AlumniHome />} />
      <Route path="/login" element={<LoginAlumni />} />
      <Route path="/signup" element={<SignupAlumni />} />
      <Route path="/dashboard" element={<DashboardAlumni />} />
    </Routes>
  );
}

export default Alumni;
